import { createSlice, createAction } from '@reduxjs/toolkit';
import {
  fetchVehicles,
  fetchVehicle,
  addVehicle,
  editVehicle,
  removeVehicle,
} from '../actions/vehicles-actions';

// Create action to set the current page
export const setCurrentPage = createAction('vehicle/setCurrentPage');
export const setSearchParams = createAction('vehicle/setSearchParams');
export const setSortBy = createAction('vehicle/setSortBy');
export const setImageToVehicle = createAction('vehicle/setImageToVehicle');

const initialState = {
  isLoading: true,
  vehicles: [],
  count: 0,
  vehicle: null,
  makes: [],
  currentPage: 1, // Add currentPage to the state
  perPage: 12, // Add perPage to manage items per page
  searchParams: {}, // Add searchParams to store the search criteria
  sortBy: ''
};

const vehicleSlice = createSlice({
  name: 'vehicle',
  initialState: initialState,
  reducers: {
    setVehicles(state, action) {
      state.vehicles = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchVehicles.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchVehicles.fulfilled, (state, action) => {
        const { vehicles, count, page } = action.payload;
        state.vehicles = vehicles;
        state.count = count;
        //state.currentPage = page;
        state.isLoading = false;
      })
      .addCase(fetchVehicles.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(fetchVehicle.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchVehicle.fulfilled, (state, action) => {
        state.isLoading = false;
        state.vehicle = action.payload;
      })
      .addCase(addVehicle.fulfilled, (state, action) => {
        const newVehicle = action.payload;
        state.vehicles.unshift(newVehicle);
        state.count += 1;
      })
      .addCase(addVehicle.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to add vehicle';
      })
      .addCase(editVehicle.fulfilled, (state, action) => {
        const editVehicle = action.payload;
        const index = state.vehicles.findIndex(
          (vehicle) => vehicle.id === editVehicle.id
        );
        if (index !== -1) {
          const existingVehicle = state.vehicles[index];

          state.vehicles[index] = {
            ...existingVehicle,
            ...editVehicle,
          };
        }
      })
      .addCase(removeVehicle.fulfilled, (state, action) => {
        const vehicleId = action.payload;
        state.vehicles = state.vehicles.filter(
          (vehicle) => vehicle.id !== vehicleId
        );
        state.count -= 1;
      })
      .addCase(setCurrentPage, (state, action) => {
        state.currentPage = action.payload; // Update the current page
      })
      .addCase(setSearchParams, (state, action) => {
        state.searchParams = action.payload; // Update the search parameters
      })
      .addCase(setSortBy, (state, action) => {
        state.sortBy = action.payload;
      })
      .addCase(setImageToVehicle, (state, action) => {
        const { vehicleId, image } = action.payload;
        const index = state.vehicles.findIndex((vehicle) => vehicle.id === vehicleId);
        
        if (index !== -1) {
          const updatedVehicle = state.vehicles[index];
          updatedVehicle.images = updatedVehicle.images || [];
          updatedVehicle.images.unshift(image);
          state.vehicles[index] = updatedVehicle;
        }
      })
  },
});

export const vehicleActions = {
  ...vehicleSlice.actions,
  setCurrentPage,
  setSearchParams,
  setImageToVehicle,
  setSortBy
};

export default vehicleSlice;
